import { Outlet, useParams } from "react-router";
import { OnboardingLayout } from "../../../../common";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getUserInfoThunk } from "../../../../redux/slices/userSlice";
import { ProgressBar } from "./progressBar";
import { Steps } from "./data/steps";
import { updateDataLayer } from "@utils/updateDataLayer";

export const OnboardingStepper = () => {
  const dispatch = useDispatch();
  const { stepIndex } = useParams();

  const currentStepIndex = parseInt(stepIndex, 10) - 1;

  const step = Steps[currentStepIndex];

  useEffect(() => {
    if (localStorage.getItem("token")) {
      dispatch(getUserInfoThunk());
      const isEventInDataLayer = window.dataLayer?.some(
        (event) => event.event === "user_id_ev"
      );
      if (isEventInDataLayer) {
        return;
      }
      updateDataLayer({
        event: "user_id_ev",
        user_id_val: localStorage.getItem("userId"),
      });
    }
  }, []);

  return (
    <OnboardingLayout
      hideNavigateBack={currentStepIndex === 0}
      headerContent={step.headerTitle ? <ProgressBar /> : undefined}
    >
      <Outlet />
    </OnboardingLayout>
  );
};
